import { useState, useEffect } from 'react';

import { FileTabUI, FormErrorUI, FormLabelUI, InputUI, TabsUI } from '../../Interface';
import ProductionOperations from './ProductionOperations';
import { Field } from 'formik';
import ProductionItem from './ProductionItem';
import jokerService from '../../../service/joker.service';
import { JokerTypes } from '../../../config/joker';
import JokerTab from '../../Interface/Joker/JokerTab';
import ProductionIssues from './ProductionIssues';
import ProductionReceipt from './ProductionReceipt';
import ProductionQuantities from './ProductionQuantities';
import useConfig from '../../../context/ConfigContext';
import ProductionConfirmation from './ProductionConfirmation';
import { FormType } from '../../../config/form';

const DescriptionPanel = (props) => {
  return (
    <div>
      <div className="col-span-full relative">
        <div className="mt-2">
          <Field
            type="text"
            name="description"
            as={InputUI}
            className={`${props.disabled ? 'rounded-md' : ''} resize-none h-36, p-2`}
            fullWidth
            label={<FormLabelUI text="Leírás" />}
            variant="standard"
            helperText={<FormErrorUI message={props.errors.description} />}
            disabled={props.disabled}
            InputLabelProps={{ shrink: props.values.description !== '' }}
            multiline
            rows={4}
          />
        </div>
      </div>
    </div>
  );
};

const ProductionTabs = (props) => {
  const { config, getConfig } = useConfig();
  const { selectedValues } = props;
  const [activeTab, setActiveTab] = useState(0);
  const [jokerGroups, setJokerGroups] = useState([]);

  const getJokerGroups = async () => {
    jokerService.getGroups(JokerTypes.PRODUCTION).then((data) => {
      setJokerGroups(data);
    });
  };

  useEffect(() => {
    getJokerGroups();
    if (!Object.keys(config).length) getConfig();
  }, []);

  const tabs = [
    {
      id: 0,
      name: 'Műveletek',
      content: <ProductionOperations {...props} />,
    },
    {
      id: 1,
      name: 'Cikkek',
      content: <ProductionItem {...props} />,
    },
    {
      id: 2,
      name: 'Megjegyzés',
      content: <DescriptionPanel {...props} />,
    },
    {
      id: 3,
      name: 'Csatolmányok',
      content: (
        <FileTabUI
          savedFiles={[...(selectedValues.sourceListAttachment ?? []), ...(selectedValues.itemAttachment ?? [])]}
          parentObj={FormType.PRODUCTION}
        />
      ),
    },
    {
      id: 4,
      name: 'Lejelelentések',
      content: <ProductionConfirmation {...props} />,
    },
    //feltételessé tenni, hogy a a config tartalmazza-e a gyártási kiadás funkciót
    ...(config?.productionStockAccounting
      ? [
          {
            id: 5,
            name: 'Alapanyag',
            content: <ProductionIssues {...props} />,
          },
          {
            id: 6,
            name: 'Bevételezés',
            content: <ProductionReceipt {...props} />,
          },
        ]
      : []),

    {
      id: 7,
      name: 'Összefoglaló',
      content: <ProductionQuantities {...props} />,
    },
    ...((jokerGroups.length > 0 &&
      jokerGroups
        .filter((group) => group.jokerFields.length > 0)
        .map((group, index) => ({
          id: index + 8,
          name: group.name,
          content: <JokerTab fields={group.jokerFields} key={index} {...props} />,
        }))) ||
      []),
  ];

  const handleTabClick = (tabIndex) => {
    setActiveTab(tabIndex);
  };

  return (
    <div className="my-4 mt-6">
      <div className="px-3">
        <TabsUI activeTab={activeTab} handleTabClick={handleTabClick}>
          {tabs.map((tab, index) => (
            <div key={index} name={tab.name}>
              {tab.content}
            </div>
          ))}
        </TabsUI>
      </div>
    </div>
  );
};

export default ProductionTabs;
